module.exports = __webpack_public_path__ + "img/ReportTemplates.5e599bb3.svg";